import { render, staticRenderFns } from "./SettingSelections.vue?vue&type=template&id=fcf70292"
import script from "./SettingSelections.vue?vue&type=script&lang=js"
export * from "./SettingSelections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports